import { create } from 'zustand';
import {
  addToEditorData,
  DEFAULT_EDITOR_DATA,
} from '@quicktools/shared-components/components/domainSpecific/text/Editor';
import { NO_FONT } from '@quicktools/shared-components/utils/fonts';
import getQueryParamValue from '@quicktools/shared-components/utils/queryParams';

import { SEARCH_STR } from '../configs';

import { IEmojiState } from './types';

const defaultCopyList = '';

const getInitialSearchTerm = () => {
  if (typeof window !== 'undefined') {
    return getQueryParamValue(SEARCH_STR);
  }

  return '';
};

const useEmojiStore = create<IEmojiState>()((set, get) => ({
  showModal: false,
  searchTerm: getInitialSearchTerm(),
  editorExpanded: false,
  canShowCopyTooltip: true,
  copyList: defaultCopyList,
  editorData: DEFAULT_EDITOR_DATA,

  toggleModal: () => {
    const { showModal } = get();

    set({
      showModal: !showModal,
    });
  },

  setSearchTerm: (searchTerm: string) => {
    set({
      searchTerm,
    });
  },

  disableHoverTooltip: () => {
    const { canShowCopyTooltip } = get();

    set({
      canShowCopyTooltip: !canShowCopyTooltip,
    });
  },

  setEditorExpanded: (editorExpanded) => {
    set({
      editorExpanded,
    });
  },

  setEditorData: (editorData) =>
    set({
      editorData,
    }),

  addToEditor: (text: string) => {
    const { editorData } = get();

    set({
      editorData: addToEditorData(editorData, text, NO_FONT),
    });
  },
}));

export default useEmojiStore;
